module.exports = __webpack_public_path__ + "static/media/eple_gronn-min.1a309e8b.png";